import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export function Layout(props) {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest);
    };

    return (
        <>
            <AuthenticatedTemplate>
                <NavMenu />
                <Container tag="main">
                    {props.children}
                </Container>
            </AuthenticatedTemplate>
            
            <UnauthenticatedTemplate>
                <Container tag="main" className="text-center mt-5">
                    <h2>Please sign in to access DeciderPro</h2>
                    <button className="btn btn-primary" onClick={handleLogin}>
                        Sign In
                    </button>
                </Container>
            </UnauthenticatedTemplate>
        </>
    );
}
